import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactGA from 'react-ga';

// components
import AppHeader from './Header';
import AppFooter from './Footer';

// locale
import localeEn from '../../locale/locale-en';

//modules
import BS from '../../theme/Bootstrap';
import styles from '../Containers.module.scss';

class App extends Component {
  static childContextTypes = {
    theme: PropTypes.object,
    locale: PropTypes.func
  };

  getChildContext() {
    return {
      theme: BS,
      locale: localeEn
    };
  }

  render() {
    const { children } = this.props;

    return (
      <div className={styles.App}>
        <AppHeader />
        <div className={styles.body}>{children}</div>
        <AppFooter />
      </div>
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.pathname !== this.props.pathname) {
      window.scrollTo(0, 0);
    }

    if (
      prevProps.pathname !== this.props.pathname ||
      prevProps.search !== this.props.search
    ) {
      ReactGA.pageview(window.location.pathname + window.location.search);
    }
  }

  componentDidMount() {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }
}

export default connect((state, props) => {
  return {
    pathname: state.routing.location.pathname,
    search: state.routing.location.search
  };
}, {})(App);



// WEBPACK FOOTER //
// ./src/containers/App/App.js